import { useTranslation } from 'react-i18next';
import styled from 'styled-components'
import { typeface, get_color, respond } from '../assets/styles/index';
import Accordion from '../component/Accordion'
import { PrimaryTitle } from '../component/PrimaryTitle';

const Container = styled('div')`
  width: 100%;
  display: flex;
  padding-bottom: 64px;
  ${respond(['m','s'], `
    flex-direction: column;
  `)}
  .body{
    flex: 1;
    ${respond(['t'], `
      padding-left: 12px;
    `)}
  }
  .answer{
    &:not(:first-child){
      padding-top: 8px;
    }
  }
`;

const Notices = styled('div')`
  ${typeface('body7')}
  margin-top: 24px;
  padding: 12px 16px;
  border: 1px solid ${get_color('divider')};
  border-radius: 3px;
  background-color: ${get_color('grey09')};
  ${respond(['m','s'], `
    margin-top: 16px;
  `)}
  span{
    ${typeface('body6')}
  }
`;

const FAQ = () => {
  const { t } = useTranslation();
  return (
    <Container>
      <PrimaryTitle>{t('faq.title')}</PrimaryTitle>
      <div className="body">
        <Accordion title={t(`faq.question_1`)} prefix="Q.">
          <div className="answer">{t(`faq.answer_1`)}</div>
        </Accordion>
        <Accordion title={t(`faq.question_2`)} prefix="Q.">
          <div className="answer">{t(`faq.answer_2`)}</div>
        </Accordion>
        <Accordion title={t(`faq.question_3`)} prefix="Q.">
          <div className="answer">{t(`faq.answer_3`)}</div>
        </Accordion>
        <Accordion title={t(`faq.question_4`)} prefix="Q.">
          <div className="answer">{t(`faq.answer_4`)}</div>
        </Accordion>
        <Accordion title={t(`faq.question_5`)} prefix="Q.">
          <div className="answer">{t(`faq.answer_5`)}</div>
        </Accordion>
        <Accordion title={t(`faq.question_6`)} prefix="Q.">
          <>
            <div className="answer">{t(`faq.answer_6_1`)}</div>
            <div className="answer">{t(`faq.answer_6_2`)}</div>
            <div className="answer">{t(`faq.answer_6_3`)}</div>
            <div className="answer">{t(`faq.answer_6_4`)}</div>
          </>
        </Accordion>
        <Notices role="text" dangerouslySetInnerHTML={{__html:t(`faq.notices`)}}></Notices>
      </div>
    </Container>
  );
}

export default FAQ;
